webpackJsonp([5],{

/***/ 205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(306);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282596e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(312);
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_282596e3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 213:
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fcccfea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderView_vue__ = __webpack_require__(234);
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fcccfea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"position":"relative","padding":"0px"}},[_c('h1',{staticClass:"text-white",style:({ 'font-size': _vm.$store.state.screenWidth <=320 ? '24px':'32px' })},[_vm._v("RMUTL Open House")]),_vm._v(" "),_c('span',{staticClass:"badge badge-pill bg-rmutl p-2",staticStyle:{"font-family":"'Mitr', sans-serif"}},[_vm._v("มหาวิทยาลัยเทคโนโลยีราชมงคลล้านนา")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(292), __esModule: true };

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(213);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),

/***/ 306:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__layouts_HeaderView_vue__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_services__ = __webpack_require__(155);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    HeaderView: __WEBPACK_IMPORTED_MODULE_1__layouts_HeaderView_vue__["a" /* default */]
  },
  data: function data() {
    return {
      citizen_id: '',
      checkVal: false
    };
  },

  methods: {
    validateForm: function validateForm() {
      if (this.citizen_id.length === 13) {
        if (this.THAIIDCHECK(this.citizen_id) === true) {
          this.Login(this.citizen_id);
        } else {
          this.checkVal = true;
        }
      } else if (this.citizen_id.length === 9) {
        this.Login(this.citizen_id);
      } else {
        this.checkVal = true;
      }
    },
    Login: function Login(citizenId) {
      var _this = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__assets_services__["a" /* default */].OAuthCheck(this.$store.state.URL, { citizenId: citizenId }, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          localStorage.token = result.data.accessToken;
          _this.OAuth(citizenId);
          _this.$router.push('/activity').catch(function () {});
        } else if (result.status === 'NOT_REGISTER') {
          _this.$router.push('/regis/' + citizenId).catch(function () {});
        } else {
          __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
            title: 'ตรวจสอบ',
            text: result.message,
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'ลองใหม่อีกครั้ง',
            denyButtonText: 'ยกเลิก'
          }).then(function (result) {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              _this.Login();
            } else if (result.isDenied) {
              _this.citizen_id = '';
            }
          });
          localStorage.clear();
        }
        _this.$store.state.isLoading = false;
      }, function (error) {
        _this.$store.state.isLoading = false;
        __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default.a.fire({
          title: 'ตรวจสอบ',
          text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error),
          icon: 'error',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'ลองใหม่อีกครั้ง',
          denyButtonText: 'ยกเลิก'
        }).then(function (result) {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            _this.Login();
          } else if (result.isDenied) {
            _this.citizen_id = '';
          }
        });
      });
    }
  },
  mounted: function mounted() {
    var auth = this.callbackToken(this.citizen_id);
    if (auth) {
      this.$router.push('/activity').catch(function () {});
    }
  }
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('HeaderView'),_vm._v(" "),_c('div',{class:{
      'bg-content': _vm.$store.state.screenWidth > 375,
      'bg-content-se': _vm.$store.state.screenWidth <= 375,
      'bg-content-4': _vm.$store.state.screenWidth <= 320,
    }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h2',{class:{
              'mt-3': _vm.$store.state.screenWidth <= 320,
              'mt-5': _vm.$store.state.screenWidth > 320,
            },staticStyle:{"font-family":"'Mitr', sans-serif","font-size":"30px"}},[_c('img',{attrs:{"src":"/static/img/icons/apple-touch-icon-60x60.png"}}),_vm._v("\n             เข้าร่วมงาน\n          ")]),_vm._v(" "),_c('div',{class:{
              'mt-3 mb-3': _vm.$store.state.screenWidth <= 320,
              'mt-4 mb-4': _vm.$store.state.screenWidth > 320,
            }},[_c('label',{staticClass:"mb-2",attrs:{"for":"citizen"}},[_vm._v("\n              รหัสบัตรประชาชนหรือเลขพาสปอร์ต\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.citizen_id),expression:"citizen_id"}],staticClass:"form-control",staticStyle:{"font-family":"'Mitr', sans-serif"},attrs:{"type":"text","maxlength":"13","id":"citizen","autocomplete":"off"},domProps:{"value":(_vm.citizen_id)},on:{"keyup":[function($event){_vm.checkVal = false},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.validateForm.apply(null, arguments)}],"input":function($event){if($event.target.composing){ return; }_vm.citizen_id=$event.target.value}}}),_vm._v(" "),(_vm.checkVal)?_c('small',{staticClass:"text-danger"},[_vm._v("\n              กรุณากรอกรหัสประจำตัวประชาชนหรือเลขพาสปอร์ตให้ถูกต้อง\n            ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn bg-rmutl text-white",staticStyle:{"width":"100%","font-size":"22px","font-family":"'Mitr', sans-serif"},on:{"click":_vm.validateForm}},[_c('i',{staticClass:"ti ti-login"}),_vm._v("\n             เข้าสู่ระบบ\n          ")]),_vm._v(" "),_c('div',{staticClass:"mt-4 text-center",staticStyle:{"font-family":"'Mitr', sans-serif","color":"gray"},style:({
              'font-size': _vm.$store.state.screenWidth <= 320 ? '11px' : '14px',
            })},[_vm._v("\n            เปิดบ้านราชมงคลล้านนา\n            "),_c('br'),_vm._v("\n            RMUTL OPEN HOUSE\n            "),_c('br'),_vm._v("\n            เรียนรู้ สร้างสรรค์ เทคโนโลยี ก้าวสู่อาชีพ\n            "),_c('br'),_vm._v("\n            พัฒนาโดย\n            "),_c('a',{attrs:{"href":"https://www.facebook.com/ARITRMUTL.Official","target":"_blank"}},[_vm._v("\n              สำนักวิทยบริการและเทคโนโลยีสารสนเทศ\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"})])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/5.03aeee13aaa9a5d9d8d6.js